import React, { Component, Fragment } from 'react'
import { Container,Nav, Navbar, NavDropdown } from 'react-bootstrap'
import blackLogo from '../../asset/image/jj.png';
import whiteLogo from '../../asset/image/ng.png';
import { NavLink } from "react-router-dom";


export class header extends Component {
   constructor(){
    super();
    this.state={
        navBarHeader: "navHeader",
        navBarLogo: [blackLogo], //its an object ager tar moto nah
        navBarBack:"navBackground",
        navBarFontColor:"navFontColor"

    }
   }
   onScroll=()=>{
    if(window.scrollY>100){
        this.setState({navBarHeader:'navHeaderScroll', navBarLogo:[whiteLogo], navBarBack:'navBackgroundScroll', navBarFontColor:'navFontColorScroll'})

    }else if(window.scrollY<100){
         this.setState({navBarHeader:'navHeader', navBarBack:'navBackground', navBarFontColor:'navFontColor' }) //navBarLogo:[blackLogo]
    }
   }
   componentDidMount(){
    window.addEventListener('scroll', this.onScroll)
   }



  render() {
    return (
     <Fragment> 
       
          <Navbar className={this.state.navBarBack} collapseOnSelect fixed='top' expand="lg"  variant='dark' >
      <Container>
        <Navbar.Brand  className={`${this.state.navBarHeader} ${this.state.navBarFontColor}{navbarfonthover}`}  href="#home">Markham Bazaar
          <NavLink to="/"><img src={this.state.navBarLogo}></img> </NavLink></Navbar.Brand>
        

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">

         <Nav.Link>  <NavLink exact activeStyle={{color:'#ffd900'}} className={this.state.navBarFontColor} to="/">Home</NavLink>  </Nav.Link> 
           <Nav.Link>   <NavLink exact activeStyle={{color:'#ffd900'}}  className={this.state.navBarFontColor} to="/events">Events</NavLink>  </Nav.Link> 
            <Nav.Link>    <NavLink exact activeStyle={{color:'#ffd900'}} className={this.state.navBarFontColor} to="/Organizer">Organizer</NavLink> </Nav.Link> 
            <Nav.Link>      <NavLink  className={this.state.navBarFontColor} to="/galleryPage">Gallery</NavLink> </Nav.Link> 
              <Nav.Link>    <NavLink exact activeStyle={{color:'#ffd900'}} className={this.state.navBarFontColor} 
              
               smooth={true} duration={500} to="/about">About Us</NavLink>  </Nav.Link> 
             <Nav.Link>      <NavLink  className={this.state.navBarFontColor} to="/upcomingevents">Up Coming Events</NavLink>  </Nav.Link> 
              <Nav.Link>      <NavLink  className={this.state.navBarFontColor} to="/contact">Contact</NavLink>  </Nav.Link> 
          </Nav>
          
     
          <Nav>
             
          
       
                    <Nav.Link> <NavLink  className={this.state.navBarFontColor} to="/visitorregistration"> || Visitor's Registration</NavLink>   </Nav.Link> 
                    <Nav.Link>   <NavLink  className={this.state.navBarFontColor} to="/VendorRegistration">  Vendor's Registration</NavLink></Nav.Link> 
            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
        


     </Fragment>


    )
  }
}

export default header
